import restClient from "./BackendRestClient";

export function getAllComments(shipmentId) {
    return restClient.get(["comment", "all"].join("/"), {
        params: {shipmentId}
    }).then(res => res)
}

export function addComment(shipmentId, comment) {
    return restClient.post(["comment", "add"].join("/"), comment, {
        params: {shipmentId}
    }).then(res => res)
}

export function getPartyTypes(shipmentId, group) {
    return restClient.get(["comment", "party-types"].join("/"), {
        params: {shipmentId, group}
    }).then(res => res)
}
